/*!
 * 订阅消息辅助模块
 * 覆盖90%场景，因为业务，平台都是变化的，不可能覆盖100%场景，特别需求可以一起沟通解决，覆盖不了的地方可以自己定制化
 * 具体功能说明
 * 1.封装了微信或者支付宝到订阅消息逻辑，统一调用函数。例如：微信一行调用代码完成订阅
 * 2.封装了订阅消息成功后，自动上报给业务后台。
 * 3.采用了条件编译，在不同平台会隔离。
 * 4.支持调用后callback回调函数，例如，当用户点击ok后才同步处理后续业务逻辑。
 * 5.支持支付宝长订阅消息。
 * 使用示例：https://syounggroup.feishu.cn/docs/doccniKFrP1vjWJKwIFZZHbJqTf#
 * 官方文档：支付宝订阅消息：https://opendocs.alipay.com/mini/introduce/message
 * 官方文档：微信端订阅消息：https://developers.weixin.qq.com/miniprogram/dev/framework/open-ability/subscribe-message.html
 * 作者：huaishan
 * 更新日期：20210427
 */
// import { toast } from '../utils/prompt';
import eventReporter from './event-reporter';
import {
  getTmplIds,
  subscribeNewsReportSubscribe,
  subscribeNewsReportAliSubscribe,
  reportLongSubscribeAliPay,
  subscribeNewsGetLongTermSubscribeLog,
  subscribeNewsListAllMiniAppTemplates,
  subscribeNewsListAllTinyAppTemplates,
  onceSubscribeMsgUserSubscribeSubmit,
} from '../api/notify';
import utils from '../utils/common';
import { toast } from '@/utils/prompt';

/**
 * 内部使用，比较版本号的（微信使用）
 * @param {*} v1
 * @param {*} v2
 * @returns
 */
function compareVersion(v1, v2) {
  if (!v1 || !v2) {
    return 0;
  }
  v1 = v1.split('.');
  v2 = v2.split('.');
  const len = Math.max(v1.length, v2.length);
  while (v1.length < len) {
    v1.push('0');
  }
  while (v2.length < len) {
    v2.push('0');
  }
  for (let i = 0; i < len; i++) {
    const num1 = parseInt(v1[i]);
    const num2 = parseInt(v2[i]);
    if (num1 > num2) {
      return 1;
    } else if (num1 < num2) {
      return -1;
    }
  }
  return 0;
}

/**
 * 根据约定的模版业务代码，开始订阅消息（支付宝&微信通用）
 *
 * @param {Array} codeIds（必选）传入的业务类型数组 例如：['WAIT_PAY','ORDER_STATUS']，业务代码需要问后台同学约定
 * @param {function} userCallBack（可选）回调函数，订阅逻辑结束后调用，会返回成功或者失败标识
 * @param {Boolean} isLongSubscribe（可选）是否长订阅消息，特殊场景，一般用不上
 */
const subscribeMixing = async function(
  codeIds = [],
  userCallback = function() {},
  isLongSubscribe = false
) {
  console.log('subscribeMixing 入口 codeIds', codeIds);
  // 发现部分用户调用时候传入的是string类型
  if (typeof codeIds === 'string') {
    codeIds = codeIds.split();
    console.log('subscribeMixing 强制转换 codeIds 为 []');
  }
  const templateIdsMap = getApp().globalData.templateIdsMap;
  if (!templateIdsMap && templateIdsMap.length <= 0) {
    console.log('subscribeMixing templateIdsMap为空');
    userCallback(false);
    return;
  }
  // 调用订阅消息的入参
  const tmplIds = [];
  codeIds.map(name => {
    const value = templateIdsMap.get(name);
    if (value) {
      tmplIds.push(value);
    } else {
      console.log('subscribeMixing 未在templateIdsMap找到业务名称name:' + name);
    }
  });
  if (tmplIds.length === 0) {
    console.log('subscribeMixing tmplIds为空');
    userCallback(false);
    return;
  }














































































};

/**
 * App.js 全局调用一次，不是给各页面用的
 * 获取当前应用所有用到的模版ids数组（支付宝&微信通用）
 *
 * @param {function} callback 回调函数,业务结束后回调用
 */
const getTemplateIdsMixing = async function(callback = function() {}) {
  let result;






  const templateIdsMap = new Map();
  if (result.success && result.data && result.data.length > 0) {
    const data = result.data;
    if (data && data.length > 0) {
      data.map(item => {
        const key = item.first;
        const value = item.second;
        templateIdsMap.set(key, value);
      });
    }
  }
  if (!templateIdsMap || templateIdsMap.length <= 0) {
    callback(false, []);
  } else {
    callback(true, templateIdsMap);
  }
};

/**
 * AI测肤，特别定制
 * 每天订阅一次的封装函数
 * 此函数目前由于业务变更，暂时不使用，但是还是保留下来备用，仅供后人参考
 */
const subscribeOneTimePreDay = function(dbName, templateIds, callback) {
  if (!(templateIds && templateIds.length > 0)) {
    callback();
    return;
  }
  const STORAGE_KEY = dbName;
  const tipText = utils.parseTime(new Date(), '{y}-{m}-{d}');
  let subscribeCache = wx.getStorageSync(STORAGE_KEY) || {};
  const saveKey = JSON.stringify(templateIds) + tipText;
  console.log('subscribeByTid saveKey:' + saveKey);
  if (subscribeCache[saveKey]) {
    callback();
    return;
  }
  subscribeMixing(templateIds, callback);
  subscribeCache = {}; // 清空数据
  subscribeCache[saveKey] = true;
  wx.setStorageSync(STORAGE_KEY, subscribeCache);
};

/**
 * 兼容旧版本
 * 这个函数下个版本会删除，请调用者改用上面那个订阅
 * @param {*} ids
 * @returns
 */
const subscribeByIds = function(tmplIds, cb = function() {}) {
  console.log('subscribeById', tmplIds);
  if (tmplIds && tmplIds.length > 0) {
    const version = wx.getSystemInfoSync().SDKVersion;
    console.log('subscribeById', 'subscribeByIdsPromise() version:' + version);
    if (compareVersion(version, '2.8.2') >= 0) {
      wx.requestSubscribeMessage({
        tmplIds,
        success(res) {
          subscribeNewsReportSubscribe(tmplIds);
          tmplIds.forEach(item => {
            eventReporter.trackSubscribeMessage({
              templateId: item,
              result: res[item] === 'accept' ? '1' : res[item] === 'reject' ? '2' : '0',
            });
          });
          cb(true);
        },
        fail(res) {
          tmplIds.forEach(item => {
            eventReporter.trackSubscribeMessage({
              templateId: item,
              result: 0,
            });
          });
          cb(false);
          console.error(res.errMsg);
          // toast(res.errMsg);
        },
      });
    } else {
      console.log('subscribeById', '版本过低,无法使用订阅消息 version:' + version);
      // 如果希望用户在最新版本的客户端上体验您的小程序，可以这样子提示
      // wx.showModal({
      //   title: '提示',
      //   content: '当前微信版本过低，无法使用该功能，请升级到最新微信版本后重试。'
      // });
      cb(false);
    }
  }
};

/**
 * 兼容旧版本
 * 这个函数下个版本会删除，请调用者改用上面那个订阅
 * @param {*} ids
 * @returns
 */
const getTmplIdsByBizcode = async function(ids) {
  const response = await getTmplIds(ids);
  if (response.success && response.data && response.data.length > 0) {
    return response.data;
  } else {
    return [];
  }
};
/**
 * 上报一次性订阅内容
 */
const pushOnceSubscribeMessage = async function(postData) {
  const response = await onceSubscribeMsgUserSubscribeSubmit(postData);
  if (response.success) {
    console.log(response);
    return response;
  } else {
    return [];
  }
};

module.exports = {
  getTemplateIdsMixing,
  subscribeMixing,
  subscribeOneTimePreDay,
  subscribeByIds,
  getTmplIdsByBizcode,
  pushOnceSubscribeMessage,
};
